export const calculateTotalValues = obj =>
  typeof obj === "object" && obj !== null
    ? Object.values(obj).reduce((prev, cur) => prev + cur, 0)
    : null;
